export default __webpack_public_path__ + "static/media/calender.1f10a6ba.svg";